import { Box, Typography, styled } from "@mui/material";
import { Link, useLocation, useParams } from "react-router-dom";

const Steps = styled(Box)`
  display: grid;
  grid-template-rows: [row1-start] 42px [row1-end row2-start] 42px [row2-end];
  grid-template-columns: auto auto auto auto auto;
  grid-template-areas:
    "header header header header header"
    "footer footer footer footer footer";
  max-width: 400px;
  margin: auto;
  width: 100%;
  margin-bottom: -21px;
`;

const StepContainer = styled(Link, {
  shouldForwardProp: (prop) => prop !== "disabled",
})<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;
interface StepCircleProps {
  active?: boolean;
}
const StepCircle = styled(Box, {
  shouldForwardProp(propName) {
    return propName !== "active";
  },
})<StepCircleProps>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: white;
  ${(props) =>
    props.active
      ? `
    background: white;
    border: 1px solid black;
    color: ${props.theme.palette.primary.main};
    width: 42px;
    height: 42px;`
      : `
    color: #ccc;
    border: 1px solid #ccc;`}
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
`;

const steps = [
  { label: "Producción", path: "produccion" },
  { label: "Partidas", path: "partidas" },
  { label: "Suministros", path: "suministros" },
  { label: "Equipos", path: "equipos" },
  { label: "Transporte", path: "transporte" },
];

export const ReportStepper = () => {
  const path = useLocation().pathname;
  const id = useParams().id;
  const disableNavigation = path.includes("produccion");
  return (
    <Steps>
      {steps.map((step) => {
        const active = path.includes(step.path);
        return (
          <StepContainer
            key={step.label}
            to={`/formulario-reporte/${id}/${step.path}`}
            disabled={disableNavigation}
          >
            <Typography
              textAlign="center"
              fontSize={active ? 12 : 10}
              fontWeight={active ? "bold" : "lighter"}
            >
              {step.label}
            </Typography>
          </StepContainer>
        );
      })}
      {steps.map((step, i) => (
        <StepContainer
          key={step.path}
          to={`/formulario-reporte/${id}/${step.path}`}
          disabled={disableNavigation}
        >
          <StepCircle active={path.includes(step.path)}>{i + 1}</StepCircle>
        </StepContainer>
      ))}
    </Steps>
  );
};
